var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodiaryModalCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M18.375,3.375a15,15,0,1,0,15,15A15,15,0,0,0,18.375,3.375Zm3.8,20.43-3.8-3.8-3.8,3.8a1.152,1.152,0,1,1-1.63-1.63l3.8-3.8-3.8-3.8a1.152,1.152,0,0,1,1.63-1.63l3.8,3.8,3.8-3.8a1.152,1.152,0,0,1,1.63,1.63l-3.8,3.8,3.8,3.8a1.158,1.158,0,0,1,0,1.63A1.145,1.145,0,0,1,22.175,23.805Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#142c1f",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodiaryModalCloseIcon);
export default __webpack_public_path__ + "static/media/Foodiary-modal-close-icon.3492ffeccfff783c63323cbeb378d0fe.svg";
export { ForwardRef as ReactComponent };